import { render, staticRenderFns } from "./PaymentWithWallet.vue?vue&type=template&id=79ff148a&"
import script from "./PaymentWithWallet.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaymentWithWallet.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports